import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';

import {
  useRetailBuyerSelector,
  UseRetailBuyerSelectorOptions,
} from './useRetailBuyerSelector';

export const RetailBuyerSelector = ({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  placeholderText,
  ...props
}: Omit<PosSelectProps, 'valueOptionsContent'> &
  UseRetailBuyerSelectorOptions) => {
  const {
    query: { isLoading },
    posSelectProps,
  } = useRetailBuyerSelector({
    disabled,
    additionalOptions,
    additionalOptionsPosition,
    placeholderText,
  });

  return (
    <PosSelect
      {...props}
      loading={isLoading}
      disabled={disabled}
      allowSearchAsInput
      {...posSelectProps}
    />
  );
};
